<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Habilitar tarima</h5>
        <!-------------------- START - Controles arriba de tabla-------------------->
        <div class="controls-above-table">
          <div class="row">
            <div class="col-12">
              <div
                style="
                  border-left: 6px solid #0087ff !important;
                  color: #000 !important;
                  background-color: #ddffff !important;
                "
                class="alert alert-light"
                role="alert"
              >
                <h4 class="alert-heading text-dark">Observaciones</h4>
                <p class="font-weight-bold"></p>
                <h6 class="fas fa-info text-info"></h6>
                <span class="text-dark font-weight-bold">
                  Solo se puede abrir la tarima con un maximo de 8 dias despues
                  de la fecha de creacion de la tarima.
                </span>
                <p class="mb-0"></p>
              </div>
              <div class="row">
                <div class="col-4">
                  <label>Barra de Tarima</label>
                  <input
                    @input="buscarTarima(current)"
                    v-model="current.barra"
                    v-on:keyup.enter="buscarTarima(tarima)"
                    class="form-control"
                    type="text"
                  />
                </div>
                <div class="col-4">
                  <label># de Tarima</label>
                  <input
                    @input="buscarTarima(current)"
                    v-model="current.numero"
                    v-on:keyup.enter="buscarTarima(tarima)"
                    class="form-control"
                    type="text"
                  />
                </div>
                <div class="col-4">
                  <label>Fecha Recepción Tarima</label>
                  <input
                    @input="buscarTarima(current)"
                    v-model="searchtext"
                    v-on:keyup.enter="buscarTarima(tarima)"
                    class="form-control"
                    type="date"
                  />
                </div>
              </div>
            </div>
            &nbsp;
            <div v-if="errors != null" class="col-12">
              <span class="text-danger ont-weight-bold">""{{ errors }}""</span>
            </div>
            <div class="col-12">
              <div
                style="
                  border-left: 6px solid #00a900 !important;
                  color: #000 !important;
                  background-color: #f7fff6 !important;
                "
                class="alert alert-light"
                role="alert"
              >
                <h4 class="alert-heading text-dark">Información de tarimas</h4>
                <table class="table table-striped table-lightborde">
                  <thead>
                    <tr>
                      <th class="text-center">#</th>
                      <th class="text-center">barra</th>
                      <th class="text-center">Tienda Origen</th>
                      <th class="text-center">Tienda Destino</th>
                      <th class="text-center">Tipo</th>
                      <th class="text-center">Fecha Creación</th>
                      <th class="text-center">Fecha Recepción</th>
                      <th class="text-center">Estado</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="detalle in tarimas" v-bind:key="detalle.id">
                      <td class="text-center">{{ detalle.numero }}</td>
                      <td class="text-center">{{ detalle.barra }}</td>

                      <td class="text-center">
                        {{ detalle.tienda_origen_obj.nombre }}
                      </td>
                      <td class="text-center">
                        {{ detalle.tienda_destino_obj.nombre }}
                      </td>
                      <td v-if="detalle.salida_e_objeto" class="text-center">
                        {{ detalle.salida_e_objeto.tipo_traslado_str }}
                      </td>
                      <td class="text-center">
                        {{
                          detalle.fecha_creacion | moment("DD/MM/YYYY HH:MM:ss")
                        }}
                      </td>
                      <td class="text-center">
                        {{
                          detalle.fecha_recepcion_tarima
                            | moment("DD/MM/YYYY HH:MM:ss")
                        }}
                      </td>
                      <td class="text-center">
                        {{ detalle.estado_str }}
                      </td>
                      <td class="text-center">
                        <div class="btn-group dropleft">
                          <a
                            class="btn btn-sm btn-info dropdown-toggle"
                            href="#"
                            role="button"
                            id="dropdownMenuLink"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          >
                            Opciones
                          </a>
                          <div
                            class="dropdown-menu"
                            aria-labelledby="dropdownMenuLink"
                          >
                            <a
                              class="dropdown-item"
                              @click="abrirTarima(detalle)"
                              style="background-color: #76caf5"
                              >Habilitar Tarima
                            </a>
                            <a
                              data-target="#modalproducto"
                              data-toggle="modal"
                              href="#"
                              @click="select(detalle)"
                              class="dropdown-item"
                              style="background-color: #9fff8a"
                              >Reiniciar Conteo de Tarima
                            </a>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="modal-footer row">
                  <button
                    class="btn btn-sm btn-dark btn-block"
                    ref="cerrarModal"
                    type="button"
                    @click="resetData()"
                  >
                    Limpiar Data
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="modalproducto"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">¿Qué producto?</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <ProductoSelectComponentV2 :current="current" />
              </div>
              <div class="col-md-12">
                <UsuariosSelectComponent
                  titulo="Usuario Solicita Habilitación"
                  :current="current"
                />
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label
                    v-bind:class="{
                      'text-danger':
                        errors != null &&
                        errors.observaciones &&
                        errors.observaciones.length > 0,
                    }"
                    >Observaciones</label
                  >
                  <textarea
                    class="form-control"
                    rows="3"
                    v-model="current.observaciones"
                    autofocus="autofocus"
                    placeholder="Descripción"
                    v-bind:class="{
                      'is-invalid':
                        errors != null &&
                        errors.observaciones &&
                        errors.observaciones.length > 0,
                    }"
                  >
                  </textarea>
                  <small
                    v-if="
                      errors != null &&
                      errors.observaciones &&
                      errors.observaciones
                    "
                    class="form-text text-danger"
                    >{{ errors.observaciones[0] }}</small
                  >
                </div>
              </div>
            </div>
            <div v-if="errors != null" class="col-12">
              <span class="text-danger ont-weight-bold">""{{ errors }}""</span>
            </div>
          </div>
          <div class="modal-footer">
            <button
              @click="reiniciarConteo()"
              class="btn btn-success btn-block btn-md"
            >
              Reiniciar conteo
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";
import ProductoSelectComponentV2 from "@/components/commons/ProductoSelectComponentV2";
import UsuariosSelectComponent from "@/components/commons/UsuariosSelectComponent";

export default {
  components: {
    ProductoSelectComponentV2,
    UsuariosSelectComponent,
  },
  data() {
    return {
      tarimas: "",
      tarima: "",
      tarima_: "",
      mostrarRefresh: false,
      current: {
        producto: "",
        descripcion: "",
      },
      currentPage: 1,
      searchtext: "",
      filter_activo: "",
      data: [],
      errors: {
        descripcion: "",
      },
    };
  },
  mounted() {},
  methods: {
    select(d) {
      this.tarima = d;
      console.log(this.tarima_);
    },
    buscarTarima(current) {
      let self = this;
      if (!current.barra && !current.numero && !this.searchtext) {
        self.errors = null;
        self.tarima = "";
        return;
      }
      DynamicService.fetch("wms", "tarima", {
        barra: current.barra,
        numero: current.numero,
        "filter[search]": this.$data.searchtext,
      })
        .then((response) => {
          self.tarimas = response.data.results;
          if (!self.tarimas[0]) {
            self.errors = "Tarima no existe";
            return;
          } else {
            self.errors = null;
          }
        })
        .then((errors) => {});
    },
    resetData() {
      let self = this;
      self.tarimas = "";
      self.tarima = "";
      self.current.numero = "";
      self.current.barra = "";
      self.errors = null;
      this.searchtext = "";
    },
    abrirTarima(tarima) {
      let self = this;
      DynamicService.postAction("wms", "tarima", tarima.id, "abrir")
        .then((response) => {
          Notifications.alert.success(
            "Habilitar Tarima",
            "Realizado Correctamente"
          );
          self.resetData();
        })
        .catch((errors) => {
          Notifications.alert.error(
            "Habilitar Tarima",
            errors.response.data.detail
          );
          self.resetData();
        });
    },
    reiniciarConteo() {
      let self = this;
      let params = {
        producto_barra: null,
        usuario_solicita: null,
        observaciones: null,
      };
      console.log(self.current);
      if (self.current.producto != null) {
        params.producto_barra = self.current.producto.sku;
      }

      if (self.current.usuario != null) {
        params.usuario_solicita = self.current.usuario.username;
      }

      params.observaciones = self.current.observaciones;

      console.log(params);

      DynamicService.postAction(
        "wms",
        "tarima",
        this.tarima.id,
        "reiniciar_conteo",
        params
      )
        .then((response) => {
          Notifications.alert.success(
            "Reiniciar Conteo",
            "Realizado Correctamente"
          );
          self.resetData();
          $("#modalproducto").modal("hide");
          this.tarima_.producto = "";
        })
        .catch((errors) => {
          console.log(errors.response.data);
          if (!errors.response.data.detail) {
            self.errors = errors.response.data;
            if (errors.response.data.producto_barra) {
              self.errors.producto = errors.response.data.producto_barra;
            }
            if (errors.response.data.usuario_solicita) {
              self.errors.usuario = errors.response.data.usuario_solicita;
            }
          } else {
            self.errors = errors.response.data.detail;
            Notifications.alert.error(
              "Reiniciar Conteo",
              errors.response.data.detail
            );
          }
          // this.tarima_.producto = "";
          // $("#modalproducto").modal("hide");
        });
    },
  },
};
</script>